import { ActionMenu } from "@telluscompany/design-system";
import { Edit, MoreVerticalIcon, Trash2 } from "lucide-react";

import { useLocalization } from "@i18n";

import type { AdminStructureReservoirManagementListItem } from "../../api/structures/structures.types";

export type AdminStructureReservoirManagementActionMenuProps = {
  row: AdminStructureReservoirManagementListItem;
  onEdit: (row: AdminStructureReservoirManagementListItem) => void;
  onDelete: (row: AdminStructureReservoirManagementListItem) => void;
};

export const AdminStructureReservoirManagementActionMenu = ({
  row,
  onEdit,
  onDelete,
}: AdminStructureReservoirManagementActionMenuProps) => {
  const { translate } = useLocalization();

  return (
    <ActionMenu
      menu={[
        {
          actions: [
            {
              label: translate("admin.structures.reservoirManagement.button.edit"),
              onClick: () => onEdit(row),
              icon: <Edit size={16} />,
            },
            {
              label: translate(
                "admin.structures.reservoirManagement.button.delete",
              ),
              onClick: () => onDelete(row),
              icon: <Trash2 size={16} />,
              colorTitle: "red" as const,
            },
          ],
        },
      ]}
      trigger={
        <MoreVerticalIcon data-testid="reservoir-management-action-menu-trigger" />
      }
    />
  );
};
